import styled from 'styled-components'

const Footnote = styled.p`
  color: ${({ theme }) => theme.colors.stone};
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  margin: 0;
`

export default Footnote
